import { Edit } from 'react-admin'

import PodcasterForm from './ChannelForm'

const ChannelEdit = props => {
  return (
    <Edit undoable={false} {...props}>
      <PodcasterForm permissions={props.permissions} />
    </Edit>
  )
}

export default ChannelEdit
